<template lang="html">
  <div :style="`opacity: ${show};`" class="intro">
    <div class="intro-text">Смахивайте влево или вправо</div>
    <div class="intro-icons" :style="transform">
      <img v-if="pos < 0" class="intro-nope" src="../assets/unlike.svg">
      <img v-else-if="pos => 0" class="intro-like" src="../assets/like.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeIntro',
  data () {
    return {
      pos: 0,
      opacity: 0,
      show: 1,
    }
  },
  computed: {
    transform () {
      return {
        opacity: this.opacity,
        transform: `translate(${this.pos*200}px, ${this.pos*this.pos*30}px) rotate(${this.pos*15}deg)`
      }
    }
  },
  methods: {
    animate: function () {
      const tl = new TimelineMax();
      TweenMax.to(this, 0.1, {opacity: 1});
      tl.to(this, 0.2, {show: 1});
      tl.to(this, 0.6, {pos: 1, ease: Back.easeOut.config(1)});
      tl.to(this, 0.4, {pos: 0, ease: Power4.easeOut});
      tl.to(this, 0.6, {pos: -1, delay: 0.3, ease: Back.easeOut.config(1)});
      tl.to(this, 0.4, {pos: -0.0001, ease: Power4.easeOut});
      tl.to(this, 0.2, {show: 0});
    },
    stop () {
      clearInterval(this.timeoutID)
      TweenMax.set(this.$el, {'z-index': 0});
    }
  },
  mounted: function () {
    setTimeout(this.animate.bind(this), 1500)
    this.timeoutID = setInterval(this.animate.bind(this), 10000)
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

.intro {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  z-index: 2;
  pointer-events: none;
}

.intro-text {
  background-color: white;
  padding: 15px;
  border-radius: 60px;
}

.intro-icons {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 124px;
  width: 124px;
  margin-left: -64px;
  margin-top: -64px;
  opacity: 0;
  img {
    height: 124px;
    width: 124px;
    position: absolute;
    // opacity: 0;
  }
}

.intro-icons.to-left {
  // transform: translate(150%, 50%) rotate(10deg);
}

.intro-nope {

}

</style>



// WEBPACK FOOTER //
// src/components/HomeIntro.vue